import { Flex, Icon, Stack, Text, Tooltip } from "@chakra-ui/react"
import capitalize from "lodash.capitalize"
import type { FC } from "react"

import { shortenSupport } from "common/components/charts/helpers"
import { getVoteStyles } from "common/helpers/voteStyle"
import Minus from "ui/components/icons/Minus"
import { VoteType } from "query/graphql"

type KeyProps = {
  supports?: string[]
}

const Key: FC<KeyProps> = ({
  supports = [VoteType.For, VoteType.Against, VoteType.Abstain],
}) => {
  const voteStyles = getVoteStyles(supports)

  return (
    <Flex align="flex-end" justify="space-between">
      <Stack isInline align="center" spacing={4}>
        {supports.map((support) => {
          const { color } = voteStyles[support]
          const label = capitalize(support)

          return (
            <Stack
              key={`timeline_legend_type_${support}`}
              isInline
              align="center"
              spacing={2}
            >
              <Icon as={Minus} color={color} h="30px" w="20px" />
              <Tooltip label={label}>
                <Text color="gray.600" textStyle="body.bold.md">
                  {shortenSupport(label)}
                </Text>
              </Tooltip>
            </Stack>
          )
        })}
      </Stack>
    </Flex>
  )
}

export default Key
